import React, {useEffect} from 'react';
import {Col, Row} from 'reactstrap';
import {connect, useSelector} from "react-redux";
import {getStateByPath} from "../../../redux/selectors";

// components
import CategoryModuleList from "./_list";
import { showLoader} from "../../../components/loader/loader";

// actions
import {
    setForm,
    setItem,
    ADD_STATE,
    REMOVE_STATE,
} from "../../../redux/actions/generics/IndexedActions";



function CategoryModule(props) {
    const path = props.path || 'ui/categoryModule';
    const componentState = useSelector(state => getStateByPath(state, path));
    const { loading } = componentState?.data || false;

    useEffect(() => {
        props.ADD_STATE(path);

        return () => {
            props.REMOVE_STATE(path);
        }
    }, []);

    return (
        <div>
            {loading && showLoader()}
            <Row>
                <Col md="12">
                    {componentState && <CategoryModuleList path={path}/>}
                </Col>
            </Row>
        </div>
    );
}

const mapStateToProps = _ => ({});

const mapActionsToProps = ({
    ADD_STATE,
    REMOVE_STATE,
    setForm,
    setItem
});

export default connect(mapStateToProps, mapActionsToProps)(CategoryModule)

